import React, { useState } from "react";
import { Carousel, Pagination } from "react-bootstrap";
import './CarouselViewer.scss';

const CarouselViewer = ({ userPostDraft }) => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div>
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        controls={false}
        indicators={false}
        interval={null}>
        {userPostDraft.carousel_media_urls
          .filter(imageUrl => imageUrl)
          .map((imageUrl) => (
            <Carousel.Item key={imageUrl}>
              {(imageUrl.slice(-4) == '.mp4') ? (
                <React.Fragment>
                  <video className="m-auto custom-video">
                    <source src={imageUrl} />
                  </video>
                  < i className="fas fa-play carousel-video-icon"></i>
                </React.Fragment>
              ) : (
                <img className="m-auto custom-img" src={imageUrl} />
              )}
            </Carousel.Item>
          ))}
      </Carousel>

      <Pagination className="mt-4 justify-content-between">
        <Pagination.Prev
          disabled={index <= 0}
          onClick={() => handleSelect(index - 1)}
          className="custom-pagination"
        />
        {userPostDraft.carousel_media_urls.length <= 3 ? (
          <React.Fragment>
            {userPostDraft.carousel_media_urls.map((image_url, item_index) => (
              <Pagination.Item
                active={index == item_index}
                onClick={() => handleSelect(item_index)}
                className="custom-pagination"
                key={image_url}>
                {item_index + 1}
              </Pagination.Item>
            ))}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Pagination.Item
              active={index == 0}
              onClick={() => handleSelect(0)}
              className="custom-pagination">
              1
            </Pagination.Item>

            <Pagination.Ellipsis className="custom-pagination" />

            <Pagination.Item
              active={index == userPostDraft.carousel_media_urls.length - 1}
              onClick={() => handleSelect(userPostDraft.carousel_media_urls.length - 1)}
              className="custom-pagination">
              {userPostDraft.carousel_media_urls.length}
            </Pagination.Item>
          </React.Fragment>
        )}


        <Pagination.Next
          disabled={index >= userPostDraft.carousel_media_urls.length - 1}
          onClick={() => handleSelect(index + 1)}
          className="custom-pagination"
        />
      </Pagination>
    </div>
  );
}
export default CarouselViewer;